export default __webpack_public_path__ + "static/media/deposit-qrcode-step3.4bea1ac9.png";